import Check from './Check';

export default {
  Check,
};
